import {ApiClientConfig} from './types';

export const API_CLIENT_LOAD = 'APICLIENT::LOAD';

export interface ApiClientLoadAction {
  type: typeof API_CLIENT_LOAD;
  payload: ApiClientConfig;
}

export function apiClientLoad(payload: ApiClientConfig): ApiClientLoadAction {
  return {
    payload,
    type: API_CLIENT_LOAD,
  };
}



// WEBPACK FOOTER //
// ./src/host/actions.ts